import * as Segment from './tools/segment';

export const logoutIfAlreadyIdentified = (): void => {
  Segment.logoutIfAlreadyIdentified();
};
